import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';

let drilldownControllerRef = null;

const getOffersCard = async (
  { timeFrame = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const hireCardResponse = atsHttp.post(`/reports/offers/card`, params);
  return hireCardResponse;
};

const getOfferTableAndChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/offers/chart_table`, params);
  return hireCardResponse;
};

const getOfferVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const offerResponse = atsHttp.post(`/reports/offers/visual`, params);
  return offerResponse;
};

const getRejectionReason = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const offerResponse = atsHttp.post(`/reports/rejections/visual`, params);
  return offerResponse;
};

const getOfferDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {}, customFilter },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      customFilter,
    });
    const response = await atsHttp.post(`/reports/offers/drilldown`, params, {
      signal: controller.signal,
    });
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchOffersCard = createAsyncThunk(
  'ats-reports/offers/card',
  getOffersCard
);

export const fetchOfferTableAndChart = createAsyncThunk(
  'ats-reports/offers/table-chart',
  getOfferTableAndChart
);

export const fetchOfferByDepartmentVisual = createAsyncThunk(
  'ats-reports/offers/department/visual',
  getOfferVisual
);

export const fetchOfferByLocationVisual = createAsyncThunk(
  'ats-reports/offers/location/source',
  getOfferVisual
);

export const fetchOfferByRejectionReason = createAsyncThunk(
  'ats-reports/offers/rejection/source',
  getRejectionReason
);

export const fetchOfferDrilldown = createAsyncThunk(
  'ats-reports/offers/drilldown',
  getOfferDrilldown
);
